export enum DiscountTypeId {
  CustomerReferral = 1,
  AdminOverride = 2,
  CyberMondayDeal = 3,
  DeliveryDiscount = 4,
  CourtesyDiscount = 5,
  EmployeeDiscount = 6,
  CarpoolCredits = 7,
  Campaign = 8
}

export enum DiscountTypeKey {
  AdminOverride = 'AdminOverride',
  Campaign = 'Campaign',
  CarpoolCredits = 'CarpoolCredits',
  CourtesyDiscount = 'CourtesyDiscount',
  CustomerReferral = 'CustomerReferral',
  CyberMondayDeal = 'CyberMondayDeal',
  DeliveryDiscount = 'DeliveryDiscount',
  EmployeeDiscount = 'EmployeeDiscount',
  TradeIncentive = 'TradeIncentive'
}
